import type { MapActivityDTO } from "../data/types";
import "../Styles/CrowdChip.css";

/**
 * Hur det känns på stället just nu, enligt sensorn.
 *
 * Medvetet vag. Mätningen är ett index relativt lokalens egen tysta
 * baslinje, inte ett antal personer, och trösklarna är ännu inte
 * validerade mot riktiga kvällar. Därför står det "Busy" och inte
 * "73 % fullt" — en siffra hade lovat en precision som inte finns.
 *
 * Ritar ingenting när servern inte skickar någon mätning. Ett tomt kort
 * är ärligare än "okänt", som ser ut som ett fel.
 */

type CrowdChipProps = {
  activity?: MapActivityDTO | null;
};

const LABELS: Record<string, { text: string; hint: string }> = {
  QUIET: { text: "Quiet", hint: "Not much going on right now" },
  MODERATE: { text: "Picking up", hint: "Some activity" },
  BUSY: { text: "Busy", hint: "Plenty going on" },
  FULL: { text: "Packed", hint: "About as busy as it gets here" },
};

function freshnessLabel(ageMinutes: number) {
  if (ageMinutes <= 1) return "just now";
  return `${ageMinutes} min ago`;
}

export default function CrowdChip({ activity }: CrowdChipProps) {
  if (!activity) return null;

  const label = LABELS[activity.level];
  if (!label) return null;

  return (
    <div
      className={`crowd-chip crowd-chip--${activity.level.toLowerCase()}`}
      title={`${label.hint} · measured ${freshnessLabel(activity.ageMinutes)}`}
    >
      <span className="crowd-chip-dot" aria-hidden="true" />
      <span className="crowd-chip-text">{label.text}</span>

      {/* Att mätningen är experimentell är inte finstilt — den kan ha fel,
          och den som går ut på ett "Packed" ska veta det. */}
      {activity.experimental && (
        <span className="crowd-chip-beta" title="Experimental measurement">
          beta
        </span>
      )}
    </div>
  );
}
